module.exports = __webpack_public_path__ + "static/media/boss-bar-red-03.47b3420b.png";